import { map } from 'rxjs/operators';
import { filter, Observable, of } from 'rxjs';
import { Maybe, ServiceLocation, ServiceLocationNameGQL, Site } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Pipe({ name: 'serviceLocationName', pure: false, standalone: true })
export class ServiceLocationNamePipe implements PipeTransform, OnDestroy {
  private readonly serviceLocationName = inject(ServiceLocationNameGQL);
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private id?: Maybe<ServiceLocation['id']>;
  private serviceLocationName$!: Observable<string | null>;

  public transform(id: Maybe<ServiceLocation['id']>, siteId: Site['id']): string | null {
    if (this.id !== id) {
      this.id = id;
      this.serviceLocationName$ = id ? this.fetch(id, siteId) : of(null);
    }

    return this.asyncPipe.transform(this.serviceLocationName$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(id: ServiceLocation['id'], siteId: Site['id']): Observable<string | null> {
    return this.serviceLocationName.fetch({ siteId }).pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ serviceLocations }) => serviceLocations.items.find(s => s.id === id)?.name || null),
    );
  }
}
